import * as React from 'react';
import { useMediaGalleryContext } from './use-media-gallery-context';
export const useGalleryControls = () => {
    const { dispatch, state: { activeIndex }, } = useMediaGalleryContext();
    const changeSlide = React.useCallback((index, animate = true) => {
        // ignore when index flips from last to first or first to last, will be called again later
        dispatch({ type: 'SLIDE_CHANGE', index, animate });
    }, [dispatch]);
    const slideToNextSlide = (event) => {
        event.stopPropagation();
        changeSlide(activeIndex + 1);
    };
    const slideToPreviousSlide = (event) => {
        event.stopPropagation();
        changeSlide(activeIndex - 1);
    };
    return {
        changeSlide,
        slideToNextSlide,
        slideToPreviousSlide,
    };
};
